import Vue from 'vue';
import { ResetPageDirective } from './resetPage';

export const initDirectives = () => {
    Vue.use(ResetPageDirective);
};

